const importJson = (store, jsonString, keepHistory=false) => {
  console.log(jsonString);
  store.loadJSON(JSON.parse(jsonString), keepHistory);
}

export {importJson};